import type { Unit } from "@sins2-atlas/game-data";
import { exoticCountsText, exoticsById } from "../lib/dataset";
import { ArtImage } from "./art-image";

/** The inline exotic-requirement cluster (small icon + count per exotic, names one hover
 * down) — shared by the roster's Exotics column and the comparison's Exotics row. Callers
 * handle the no-exotics case their own way (the roster cell stays blank inside a dense
 * table; the comparison row says "none" so an aligned cell is never blank).
 *
 * No `cursor-help` here, for the same reason Chip has none (2026-09-07): that cursor is half
 * of a pair with the dotted underline, and a row of icons cannot wear an underline, so the
 * cursor alone promised honesty language this cluster does not carry. Its title names the
 * exotics and still shows on hover. */
export function ExoticCounts({ unit }: { unit: Unit }) {
  if (unit.exoticPrice.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-2" title={exoticCountsText(unit.exoticPrice)}>
      {unit.exoticPrice.map((e) => {
        const info = exoticsById.get(e.exoticType);
        return (
          <span key={e.exoticType} className="inline-flex items-center gap-0.5">
            {info && <ArtImage asset={info.smallIcon} alt={info.name} className="h-4 w-4" />}
            <span className="font-mono text-[13px]">{e.count}</span>
          </span>
        );
      })}
    </span>
  );
}
